import { render, staticRenderFns } from "./OrderGiveAudit.vue?vue&type=template&id=9a56c98a&"
import script from "./OrderGiveAudit.vue?vue&type=script&lang=js&"
export * from "./OrderGiveAudit.vue?vue&type=script&lang=js&"
import style0 from "./OrderGiveAudit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports